export default function deleteStages() {
    return {
        type: deleteStages.type,
    };
}

deleteStages.type = 'DELETE_STAGES';
